import { getAxiosInstance } from "../../../../api";

export const getStatusData = async () => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(`/engraving-process-status`);
    return res;
  } catch (error) {
    return error.response.data;
  }
};
